





















export default {
  name: 'SectionContainer',
  props: {
    title: {
      required: true
    },
    mobile: {
      required: false
    },
    subType: {
      required: false,
      default: false
    },
    center: {
      required: false,
      default: false
    },
    left: {
      required: false,
      default: false
    },
    purple: {
      default: false
    },
    black: {
      default: false
    },
    noMargin: {
      default: false
    },
    maxWidth: {
      default: false
    },
    signupContainer: {
      default: false
    },
    useInterFamily: {
      default: false
    }
  }
};
